/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Fix: Algolia search dropdown drifts off-screen when the page is scrolled.
//
// Root cause: algolia_autocomplete.js positions the dropdown with
// `position: absolute` and sets `top = rect.top + scrollTop + height + 8`,
// which is a document-relative coordinate. Scrolling moves the viewport
// away from that coordinate, making the dropdown disappear.
//
// Fix: force the dropdown container to `position: fixed` (viewport-relative)
// via custom.css, and use a MutationObserver to intercept each time readjust()
// writes its absolute top value — then subtract window.scrollY to convert it
// to the correct viewport-relative coordinate.
(function () {
  // Algolia's readjust() sets top on .aa-dropdown-menu (not the wrapper span).
  // Since we force .algolia-autocomplete to position:fixed, that element is the
  // fixed containing block — so we must subtract scrollY from whatever top
  // readjust() writes onto .aa-dropdown-menu.
  function attachDropdownObserver(dropdown) {
    function correct() {
      if (dropdown.style.top) {
        var corrected = parseFloat(dropdown.style.top) - window.scrollY;
        observer.disconnect();
        dropdown.style.top = corrected + 'px';
        observer.observe(dropdown, { attributes: true, attributeFilter: ['style'] });
      }
    }
    var observer = new MutationObserver(correct);
    observer.observe(dropdown, { attributes: true, attributeFilter: ['style'] });
    correct();
  }

  // Watch for .aa-dropdown-menu to be inserted (happens on first keystroke).
  var domObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        var dropdown = node.classList && node.classList.contains('aa-dropdown-menu')
          ? node
          : node.querySelector && node.querySelector('.aa-dropdown-menu');
        if (dropdown) {
          attachDropdownObserver(dropdown);
          domObserver.disconnect();
          return;
        }
      }
    }
  });
  domObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// Get Free Sample — track availability and remove injected button if out of stock.
(function () {
  var variantAvailable = true;

  function checkAndRemove() {
    if (!variantAvailable) {
      document.querySelectorAll('.product-samples-button-wrap').forEach(function (el) {
        el.remove();
      });
    }
  }

  // Watch for the app injecting the button anywhere in the document
  new MutationObserver(checkAndRemove)
    .observe(document.documentElement, { childList: true, subtree: true });

  function updateSampleVisibility(available) {
    var sampleWrap = document.querySelector('.product-buy-buttons-sample');
    if (!sampleWrap) return;
    sampleWrap.style.display = available ? 'block' : 'none';
  }

  function updateQuantityState(available) {
    document.querySelectorAll('[data-product-quantity] input, [data-product-quantity] select').forEach(function (el) {
      el.disabled = !available;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bisTrigger = document.getElementById('BIS_trigger');
    var addBtn = document.querySelector('.product-form__add-button');
    variantAvailable = !bisTrigger && !(addBtn && addBtn.classList.contains('button--disabled'));
    checkAndRemove();
    updateSampleVisibility(variantAvailable);
    updateQuantityState(variantAvailable);
  });

  document.addEventListener('variant:changed', function (event) {
    variantAvailable = event.detail.variant && event.detail.variant.available;
    checkAndRemove();
    updateSampleVisibility(variantAvailable);
    updateQuantityState(variantAvailable);
    var shipLine = document.querySelector('[data-ship-line]');
    if (shipLine) shipLine.hidden = !variantAvailable;
  });
})();

// Move the Klaviyo average rating stars to appear directly below the product
// title. Klaviyo renders its widget asynchronously, so DOMContentLoaded is
// too early — use MutationObserver to catch it whenever it appears/fills.
(function () {
  var moved = false;

  function moveKlaviyoStars() {
    if (moved) return;
    var title = document.querySelector('.product-meta__title');
    if (!title) return;

    // Try multiple selectors — Shopify block IDs can change between saves.
    var reviews = document.querySelector(
      '[id*="klaviyo_reviews_average_rating"], [id*="klaviyo-reviews-average-rating"], [class*="klaviyo-reviews-average"]'
    );

    // Fallback: first direct child of the product form whose id contains "klaviyo"
    if (!reviews) {
      var form = document.querySelector('.product-form');
      if (form) {
        for (var i = 0; i < form.children.length; i++) {
          if ((form.children[i].id || '').toLowerCase().indexOf('klaviyo') !== -1) {
            reviews = form.children[i];
            break;
          }
        }
      }
    }

    if (!reviews || reviews === title.nextElementSibling) return;

    title.insertAdjacentElement('afterend', reviews);
    moved = true;
  }

  var observer = new MutationObserver(moveKlaviyoStars);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  moveKlaviyoStars();
})();

// Move hulkapps-reminder below the mobile quantity selector in each cart line item.
//
// Poll for the element since Hulk may inject it before or after our script runs.
(function () {
  function moveReminders() {
    var reminders = document.querySelectorAll('[class*="hulkapps-reminder"]');
    var qtys = document.querySelectorAll('.line-item__quantity.hidden-tablet-and-up');
    reminders.forEach(function (reminder, i) {
      if (reminder.dataset.moved) return;
      if (!qtys[i]) return;
      qtys[i].parentNode.insertBefore(reminder, qtys[i].nextSibling);
      reminder.dataset.moved = '1';
    });
  }

  var interval = setInterval(function () {
    if (document.querySelector('[class*="hulkapps-reminder"]')) {
      moveReminders();
      clearInterval(interval);
    }
  }, 200);

  // Stop polling after 10 seconds regardless
  setTimeout(function () { clearInterval(interval); }, 10000);
})();

// Product page pricing: Units/Cases quantity, volume tier rows and live total.
//
// - The quantity is either linked Units/Cases inputs (Units is submitted),
//   showing how many more units complete a full case with a "Round up"
//   button, or for case-pack-only products a "1 unit / N cases" select.
// - Volume tiers come from Hulk's offer API response, published as
//   window.hulkOfferTable by snippets/hulk-offer-table-hook.liquid. They are
//   rendered as simple rows in [data-volume-tiers] (Hulk's own table is hidden),
//   with the row for the current quantity highlighted.
// - The live total under the quantity applies the matching tier.
(function () {
  var quantityEl = document.querySelector('[data-product-quantity]');
  if (!quantityEl) return;

  var form = quantityEl.closest('form') || document;
  var unitsInput = quantityEl.querySelector('[name="quantity"]');
  var casesInput = quantityEl.querySelector('[data-cases-input]');
  var remainderEl = quantityEl.querySelector('[data-case-remainder]');
  var roundUpButton = quantityEl.querySelector('[data-round-up-case]');
  var casePack = parseInt(quantityEl.getAttribute('data-case-pack'), 10) || 0;

  var totalEl = form.querySelector('[data-product-total]');
  var tiersEl = form.querySelector('[data-volume-tiers]');
  var tiersListEl = form.querySelector('[data-volume-tiers-list]');
  var unitPriceCents = totalEl ? parseInt(totalEl.getAttribute('data-unit-price'), 10) || 0 : 0;

  // ── Money formatting ───────────────────────────────────────────────────
  function currencyRate() {
    return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  }

  function formatAmount(cents, decimals) {
    var parts = (cents / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function formatMoney(cents, allowFractionalCents) {
    var decimals = 2;
    if (allowFractionalCents && Math.abs(cents - Math.round(cents)) > 1e-6) {
      decimals = 4;
    }
    var amount = formatAmount(cents, decimals);
    if (decimals > 2) amount = amount.replace(/0+$/, '');

    var format = (window.theme && theme.moneyFormat) || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_match, key) {
      if (key === 'amount_no_decimals') return formatAmount(cents, 0);
      if (key === 'amount_with_comma_separator') {
        return amount.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      }
      return amount;
    });
  }

  function formatNumber(number) {
    return number.toLocaleString('en-US');
  }

  // ── Quantity: Units <-> Cases ─────────────────────────────────────────
  function getQuantity() {
    var quantity = parseInt(unitsInput.value, 10);
    return isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function setUnits(units) {
    unitsInput.value = units;
    // Let Hulk and anything else watching the quantity know it changed
    unitsInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Nudge toward full cases (never required): when the quantity isn't a whole number of
  // cases (from half a case up), say what rounding up to the next full case costs (or saves, thanks to the
  // volume tiers) and whether it lowers the price per unit, with a one-click Round up.
  function updateCaseInfo(tiers) {
    if (!casePack) return;
    var units = getQuantity();
    var remainder = units % casePack;

    if (casesInput && document.activeElement !== casesInput) {
      casesInput.value = Math.floor(units / casePack);
    }

    // Only from half a case up: below that (single units, small tests) a nudge is just noise
    var target = remainder && units >= casePack / 2 ? units + casePack - remainder : 0;
    if (remainderEl) {
      remainderEl.textContent = target ? caseNudgeText(units, target, tiers) : '';
      remainderEl.hidden = !target;
    }
    if (roundUpButton) {
      roundUpButton.hidden = !target;
      if (target) roundUpButton.textContent = 'Round up to ' + formatNumber(target);
    }
  }

  function caseNudgeText(units, target, tiers) {
    var cases = target / casePack;
    var casesLabel = formatNumber(cases) + (cases === 1 ? ' full case' : ' full cases');
    var unitNow = getUnitPrice(units, tiers);
    var unitTarget = getUnitPrice(target, tiers);
    var delta = Math.round(unitTarget * target) - Math.round(unitNow * units);

    if (delta <= 0) {
      return '· Round up to ' + formatNumber(target) + ' (' + casesLabel + ') and pay ' +
        (delta < 0 ? formatMoney(-delta) + ' less' : 'the same') + ', at ' + formatMoney(unitTarget, true) + '/each.';
    }
    var text = '· ' + formatNumber(target - units) + ' more units makes ' + casesLabel + ' for +' + formatMoney(delta);
    if (unitTarget < unitNow) text += ' and lowers your price to ' + formatMoney(unitTarget, true) + '/each';
    return text + '.';
  }

  // ── Volume tiers ──────────────────────────────────────────────────────
  // Hulk offer_levels rows: [min qty, value, type, offer text, popular flag].
  // Returns the tiers sorted by minimum quantity, or [] when there is no offer.
  function getTiers() {
    var data = window.hulkOfferTable;
    var offer = data && data.eligible_offer;
    if (!offer || offer.is_active === false || !offer.offer_levels) return [];

    var levels;
    try {
      levels = JSON.parse(offer.offer_levels);
    } catch (e) {
      return [];
    }

    return levels
      .map(function (row) {
        return { minQty: parseFloat(row[0]), value: parseFloat(row[1]), type: row[2] };
      })
      .filter(function (tier) {
        return !isNaN(tier.minQty) && !isNaN(tier.value);
      })
      .sort(function (a, b) {
        return a.minQty - b.minQty;
      });
  }

  function getTierUnitPrice(tier, baseCents) {
    switch (tier.type) {
      case 'fix_price':
        return tier.value * 100 * currencyRate();
      case '% Off':
        return baseCents * (1 - tier.value / 100);
      case 'price_discount':
        return Math.max(0, baseCents - tier.value * 100 * currencyRate());
      default:
        return baseCents;
    }
  }

  function getUnitPrice(quantity, tiers) {
    var unitCents = unitPriceCents;
    tiers.forEach(function (tier) {
      if (quantity >= tier.minQty) unitCents = getTierUnitPrice(tier, unitPriceCents);
    });
    return unitCents;
  }

  function caseLabel(minQty) {
    if (!casePack || minQty % casePack !== 0) return '';
    var cases = minQty / casePack;
    return cases === 1 ? ' (Full Case)' : ' (' + formatNumber(cases) + ' Cases)';
  }

  // Rows: [{ from, to, unitCents }], starting with the regular price below the first tier
  function getTierRows(tiers) {
    var rows = [];
    if (tiers.length && tiers[0].minQty > 1) {
      rows.push({ from: 1, to: tiers[0].minQty - 1, unitCents: unitPriceCents });
    }
    tiers.forEach(function (tier, index) {
      var next = tiers[index + 1];
      rows.push({
        from: tier.minQty,
        to: next ? next.minQty - 1 : null,
        unitCents: getTierUnitPrice(tier, unitPriceCents)
      });
    });
    return rows;
  }

  function renderTiers(quantity, tiers) {
    if (!tiersEl || !tiersListEl) return;
    if (!tiers.length) {
      tiersEl.hidden = true;
      return;
    }

    tiersListEl.innerHTML = '';
    getTierRows(tiers).forEach(function (row) {
      var isActive = quantity >= row.from && (row.to === null || quantity <= row.to);
      var range;
      if (row.to === null) {
        range = formatNumber(row.from) + '+' + caseLabel(row.from);
      } else if (row.to === row.from) {
        range = formatNumber(row.from);
      } else {
        range = formatNumber(row.from) + '–' + formatNumber(row.to);
      }

      var item = document.createElement('li');
      item.className = 'volume-tiers__row' + (isActive ? ' volume-tiers__row--active' : '');

      var label = document.createElement('span');
      label.className = 'volume-tiers__range';
      label.textContent = 'Quantity ' + range;

      var price = document.createElement('span');
      price.className = 'volume-tiers__price';
      price.textContent = formatMoney(row.unitCents, true);

      // "Save N%" against the regular (first row) price; skipped below 1%
      var savingsPercent = unitPriceCents > 0 ? Math.round((1 - row.unitCents / unitPriceCents) * 100) : 0;
      if (savingsPercent >= 1) {
        var priceGroup = document.createElement('span');
        priceGroup.className = 'volume-tiers__price-group';
        var badge = document.createElement('span');
        badge.className = 'volume-tiers__save';
        badge.textContent = 'Save ' + savingsPercent + '%';
        // Badge first so every price sits at the right edge and the prices line up
        priceGroup.appendChild(badge);
        priceGroup.appendChild(price);
        price = priceGroup;
      }

      item.appendChild(label);
      item.appendChild(price);
      tiersListEl.appendChild(item);
    });
    tiersEl.hidden = false;
  }

  // ── Live total ────────────────────────────────────────────────────────
  function renderTotal(quantity, tiers) {
    if (!totalEl) return;
    var unitCents = getUnitPrice(quantity, tiers);
    var totalCents = Math.round(unitCents * quantity);
    var regularTotalCents = unitPriceCents * quantity;
    var isDiscounted = totalCents < regularTotalCents;

    var compareEl = totalEl.querySelector('[data-product-total-compare]');
    totalEl.querySelector('[data-product-total-amount]').textContent = formatMoney(totalCents);
    compareEl.textContent = formatMoney(regularTotalCents);
    compareEl.hidden = !isDiscounted;
    totalEl.querySelector('[data-product-total-breakdown]').textContent =
      '(' + formatNumber(quantity) + ' × ' + formatMoney(unitCents, true) +
      (isDiscounted ? ' volume price' : '') + ')';

    // "You save $X" next to the total when volume pricing applies
    var savingsEl = totalEl.querySelector('[data-product-total-savings]');
    if (!savingsEl) {
      savingsEl = document.createElement('span');
      savingsEl.className = 'product-total__savings';
      savingsEl.setAttribute('data-product-total-savings', '');
      totalEl.appendChild(savingsEl);
    }
    savingsEl.textContent = isDiscounted ? 'You save ' + formatMoney(regularTotalCents - totalCents) : '';
    savingsEl.hidden = !isDiscounted;
  }

  function render() {
    var quantity = getQuantity();
    var tiers = getTiers();
    updateCaseInfo(tiers);
    renderTiers(quantity, tiers);
    renderTotal(quantity, tiers);
  }

  // ── Events ────────────────────────────────────────────────────────────
  unitsInput.addEventListener('input', render);
  unitsInput.addEventListener('change', function () {
    if (getQuantity() !== parseInt(unitsInput.value, 10)) {
      unitsInput.value = getQuantity();
    }
    render();
  });

  if (casesInput) {
    casesInput.addEventListener('input', function () {
      var cases = parseInt(casesInput.value, 10);
      if (isNaN(cases)) return;
      unitsInput.value = cases < 1 ? 1 : cases * casePack;
      render();
    });
    casesInput.addEventListener('change', function () {
      casesInput.value = Math.floor(getQuantity() / casePack);
      setUnits(getQuantity());
    });
  }

  if (roundUpButton) {
    roundUpButton.addEventListener('click', function () {
      setUnits(Math.ceil(getQuantity() / casePack) * casePack);
    });
  }

  document.addEventListener('variant:changed', function (event) {
    if (!event.target.contains(quantityEl) || !event.detail.variant) return;
    unitPriceCents = event.detail.variant.price;
    render();
  });

  document.addEventListener('hulk:offer-table', render);

  render();
})();

// Uniform product image framing for catalog cards.
//
// Product photos have very different amounts of white space (the product fills
// ~60-95% of the image). For every <img class="js-fit-product"> this measures the
// product's bounding box on a small canvas (background = the corner color, so
// white, light grey and transparent backgrounds all work), then scales and centers
// the image inside its square frame so the product's longest side always fills
// FILL of the frame. Images that can't be read (CORS) or that are already
// edge-to-edge keep the default object-fit: contain.
(function () {
  var FILL = 0.82;
  var SAMPLE = 64;
  var TOLERANCE = 18;

  function isBackground(data, i, bg) {
    if (data[i + 3] < 24) return true;
    return (
      Math.abs(data[i] - bg[0]) < TOLERANCE &&
      Math.abs(data[i + 1] - bg[1]) < TOLERANCE &&
      Math.abs(data[i + 2] - bg[2]) < TOLERANCE
    );
  }

  function measure(img) {
    var w = img.naturalWidth;
    var h = img.naturalHeight;
    if (!w || !h) return null;

    var scale = SAMPLE / Math.max(w, h);
    var cw = Math.max(1, Math.round(w * scale));
    var ch = Math.max(1, Math.round(h * scale));
    var canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, cw, ch);
    var data = ctx.getImageData(0, 0, cw, ch).data; // throws if the image is cross-origin without CORS

    // Background color: average of the four corners
    var corners = [0, (cw - 1) * 4, (ch - 1) * cw * 4, ((ch - 1) * cw + cw - 1) * 4];
    var bg = [0, 1, 2].map(function (c) {
      return corners.reduce(function (sum, i) { return sum + data[i + c]; }, 0) / 4;
    });

    var minX = cw, minY = ch, maxX = -1, maxY = -1;
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        if (!isBackground(data, (y * cw + x) * 4, bg)) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;

    return {
      x0: minX / cw, x1: (maxX + 1) / cw,
      y0: minY / ch, y1: (maxY + 1) / ch,
      width: w, height: h
    };
  }

  function fit(img) {
    if (img.dataset.fitDone) return;
    img.dataset.fitDone = 'true';

    var box;
    try {
      box = measure(img);
    } catch (e) {
      return;
    }
    if (!box) return;

    // Product size in image pixels; already edge-to-edge (e.g. lifestyle photo) -> leave as is
    var productW = (box.x1 - box.x0) * box.width;
    var productH = (box.y1 - box.y0) * box.height;
    if (box.x1 - box.x0 > 0.97 && box.y1 - box.y0 > 0.97) return;

    // Frame units per image pixel, so the product's longest side fills FILL of the frame
    var s = FILL / Math.max(productW, productH);
    var centerX = ((box.x0 + box.x1) / 2) * box.width;
    var centerY = ((box.y0 + box.y1) / 2) * box.height;

    img.classList.add('is-fitted');
    img.style.width = box.width * s * 100 + '%';
    img.style.height = box.height * s * 100 + '%';
    img.style.left = (0.5 - centerX * s) * 100 + '%';
    img.style.top = (0.5 - centerY * s) * 100 + '%';
  }

  function handle(img) {
    if (!img.classList || !img.classList.contains('js-fit-product')) return;
    if (img.complete && img.naturalWidth) fit(img);
  }

  // Images loaded later (lazy loading, Algolia re-renders, recently viewed) — load doesn't bubble, so capture it
  document.addEventListener('load', function (event) { handle(event.target); }, true);

  function scan() {
    document.querySelectorAll('img.js-fit-product').forEach(handle);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();

// ── Spec sheet modal (Product Details table) ─────────────────────────────
// Links marked data-spec-sheet open in a modal instead of a new tab. PDFs are
// shown in an iframe, images in an img; "Open in new tab" stays available because
// some mobile browsers only render the first page of an embedded PDF.
(function () {
  if (typeof HTMLDialogElement !== 'function') return;

  var dialog;

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'spec-sheet-modal';
    dialog.setAttribute('aria-label', 'Spec sheet');
    dialog.innerHTML =
      '<div class="spec-sheet-modal__header">' +
        '<p class="spec-sheet-modal__title">Spec sheet</p>' +
        '<a class="spec-sheet-modal__open" target="_blank" rel="noopener" data-spec-sheet-open>Open in new tab</a>' +
        '<button type="button" class="spec-sheet-modal__close" aria-label="Close" data-spec-sheet-close>' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="spec-sheet-modal__body" data-spec-sheet-body></div>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', function (event) {
      // Close on the close button or a click on the backdrop
      if (event.target === dialog || event.target.closest('[data-spec-sheet-close]')) dialog.close();
    });
    dialog.addEventListener('close', function () {
      dialog.querySelector('[data-spec-sheet-body]').innerHTML = '';
      document.documentElement.classList.remove('spec-sheet-modal-open');
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-spec-sheet]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    if (!dialog) buildDialog();

    var url = link.href;
    var path = url.split('?')[0].toLowerCase();
    var body = dialog.querySelector('[data-spec-sheet-body]');
    var viewer;
    if (/\.(png|jpe?g|gif|webp|svg)$/.test(path)) {
      viewer = document.createElement('img');
      viewer.alt = 'Spec sheet';
    } else {
      viewer = document.createElement('iframe');
      viewer.title = 'Spec sheet';
    }
    viewer.className = 'spec-sheet-modal__viewer';
    viewer.src = url;
    body.innerHTML = '';
    body.appendChild(viewer);
    dialog.querySelector('[data-spec-sheet-open]').href = url;

    document.documentElement.classList.add('spec-sheet-modal-open');
    dialog.showModal();
  });
})();
